import axios from 'axios';
import token from './authToken';
// import CryptoJS from 'crypto-js';
// import { Password } from '@mui/icons-material';

const infer_localUrl = 'http://localhost:9990';
// const secretKey = 'a365714e77efacceaf8e0a1708fe1a8d522ad3b45ded10b5ee40dde603cf432e';

export const PythonLoginAPI = async (user, pass) => {
  try {
    // Encrypt username and password
    // const encryptedUser = CryptoJS.AES.encrypt(user, secretKey).toString();
    // const encryptedPass = CryptoJS.AES.encrypt(pass, secretKey).toString();
    const encodedUser = btoa(user);
    const encodedPass = btoa(pass);
    const formData = new FormData();
    formData.append('username', encodedUser);
    formData.append('password', encodedPass);

    // formData.append('username', encryptedUser);
    // formData.append('password', encryptedPass);
    // user = btoa(user)
    // pass = btoa(pass)
    // formData.append('username', user);
    // formData.append('password', pass);

    const res = await axios.post(`${infer_localUrl}/user/login?self`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
        // 'Authorization': await token(), // Uncomment if you need to include an authorization token
      }
    });
    // console.log(res.data);
    return res;
  } catch (error) {
    console.log('Error Calling all Store API: ', error);
    try {
      console.log('2nd api call start 10.115.67.9');
      const encodedUser = btoa(user);
      const encodedPass = btoa(pass);
      const formData = new FormData();
      formData.append('username', encodedUser);
      formData.append('password', encodedPass);
      const res = await axios.post(`http://10.115.67.9:9990/user/login?self`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
          // 'Authorization': await token(), // Uncomment if you need to include an authorization token
        }
      });
      console.log('2nd api call end 10.115.67.9');
      return res;
    } catch (error) {
      console.log('Error Calling all Store API 2nd time: ', error);
    }
  }
};

export const footfallGraph = async (body) => {
  // const url = 'https://i6zcdr9gb5.execute-api.eu-west-2.amazonaws.com/test/store/footfall_graph';
  const url = 'https://neoe2e.neophyte.live/fm-api/api/footfall_line_cart';
  try {
    const response = await axios.post(url, body, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });

    const data = response.data;
    // console.log(data);
    return data;
  } catch (error) {
    console.log('Error Calling fetchTimelineData API: ', error);
    try {
      const url2 = url.replace('localhost', '10.115.67.9');
      const response = await axios.post(url2, body, {
        headers: {
          Accept: 'application/json',
          Authorization: await token()
        }
      });

      const data = response.data;
      // console.log(data);
      return data;
    } catch (error) {
      console.log('Error Calling fetchTimelineData API: ', error);
      throw error; // Rethrow the error to be handled by the calling code if needed
    }
    // throw error; // Rethrow the error to be handled by the calling code if needed
  }
};

export const footfallEmployeeGraph = async (body) => {
  // const url = 'https://i6zcdr9gb5.execute-api.eu-west-2.amazonaws.com/test/store/footfall_graph';
  const url = 'https://neoe2e.neophyte.live/fm-api/api/footfall_line_cart_employee';
  try {
    const response = await axios.post(url, body, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });

    const data = response.data;
    // console.log(data);
    return data;
  } catch (error) {
    console.log('Error Calling fetchTimelineData API: ', error);
    try {
      const url2 = url.replace('localhost', '10.115.67.9');
      const response = await axios.post(url2, body, {
        headers: {
          Accept: 'application/json',
          Authorization: await token()
        }
      });

      const data = response.data;
      // console.log(data);
      return data;
    } catch (error) {
      console.log('Error Calling fetchTimelineData API: ', error);
      throw error; // Rethrow the error to be handled by the calling code if needed
    }
    // throw error; // Rethrow the error to be handled by the calling code if needed
  }
};

export const avgDwelTime = async (body) => {
  // const url = 'https://i6zcdr9gb5.execute-api.eu-west-2.amazonaws.com/test/store/avg_dwell_time';
  const url = 'https://neoe2e.neophyte.live/fm-api/api/avgDwelTime';
  try {
    const response = await axios.post(url, body, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });

    const data = response.data;
    // console.log(data);
    return data;
  } catch (error) {
    console.log('Error Calling fetchTimelineData API: ', error);
    const url2 = url.replace('localhost', '10.115.67.9');
    try {
      const response = await axios.post(url2, body, {
        headers: {
          Accept: 'application/json',
          Authorization: await token()
        }
      });

      const data = response.data;
      // console.log(data);
      return data;
    } catch (error) {
      console.log('Error Calling fetchTimelineData API: ', error);
      throw error; // Rethrow the error to be handled by the calling code if needed
    }
    // throw error; // Rethrow the error to be handled by the calling code if needed
  }
};

export const uniqueJourney = async (body) => {
  const url = 'https://i6zcdr9gb5.execute-api.eu-west-2.amazonaws.com/test/store/unique_journy';
  try {
    const response = await axios.post(url, body, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });

    const data = response.data;
    // console.log(data);
    return data;
  } catch (error) {
    console.log('Error Calling fetchTimelineData API: ', error);
    const url2 = url.replace('localhost', '10.115.67.9');
    try {
      const response = await axios.post(url2, body, {
        headers: {
          Accept: 'application/json',
          Authorization: await token()
        }
      });

      const data = response.data;
      // console.log(data);
      return data;
    } catch (error) {
      console.log('Error Calling fetchTimelineData API: ', error);
      throw error; // Rethrow the error to be handled by the calling code if needed
    }
    // throw error; // Rethrow the error to be handled by the calling code if needed
  }
};

export const journeyToFirstZone = async (body) => {
  const url = 'https://neoe2e.neophyte.live/fm-api/api/firstZoneOfCustomer';
  try {
    const response = await axios.post(url, body, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    const data = response.data;
    return data;
  } catch (error) {
    console.log('Error Calling JourneyToFirstZone API: ', error);
    const url2 = url.replace('localhost', '10.115.67.9');
    try {
      const response = await axios.post(url2, body, {
        headers: {
          Accept: 'application/json',
          Authorization: await token()
        }
      });

      const data = response.data;
      // console.log(data);
      return data;
    } catch (error) {
      console.log('Error Calling fetchTimelineData API: ', error);
      throw error; // Rethrow the error to be handled by the calling code if needed
    }
  }
};

export const footfallCard = async (body) => {
  const url = 'https://neoe2e.neophyte.live/fm-api/api/footfall';
  try {
    // const url = 'https://neoe2e.neophyte.live/fm-api/api/footfall';

    const response = await axios.post(url, body, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    const data = response.data;
    // console.log(data)
    return data;
  } catch (error) {
    console.log('Error Calling fetchTimelineData API: ', error);
    const url2 = url.replace('localhost', '10.115.67.9');
    try {
      // const url = 'https://neoe2e.neophyte.live/fm-api/api/footfall';

      const response = await axios.post(url2, body, {
        headers: {
          Accept: 'application/json',
          Authorization: await token()
        }
      });
      const data = response.data;
      // console.log(data)
      return data;
    } catch (error) {
      console.log('Error Calling fetchTimelineData API: ', error);
      throw error;
    }
    // throw error;
  }
};

// export const empfootFallCard = async (body) => {
//   console.log(body);
//   // const url = 'https://neoe2e.neophyte.live/fm-api/api/employee_footfall';
//   const url = 'https://neoe2e.neophyte.live/fm-api/api/avgFootfall_employee';
//   try {
//     // const url = 'https://neoe2e.neophyte.live/fm-api/api/femployee_footfall';

//     const response = await axios.post(url, body, {
//       headers: {
//         Accept: 'application/json',
//         Authorization: await token()
//       }
//     });
//     const data = response.data;
//     // console.log(data)
//     return data;
//   } catch (error) {
//     console.log('Error Calling fetchTimelineData API: ', error);
//     const url2 = url.replace('localhost', '10.115.67.9');
//     try {
//       // const url = 'https://neoe2e.neophyte.live/fm-api/api/employee_footfall';

//       const response = await axios.post(url2, body, {
//         headers: {
//           Accept: 'application/json',
//           Authorization: await token()
//         }
//       });
//       const data = response.data;
//       // console.log(data)
//       return data;
//     } catch (error) {
//       console.log('Error Calling fetchTimelineData API: ', error);
//       throw error;
//     }
//     // throw error;
//   }
// };

export const empFootfallCount = async (body) => {
  console.log(body);
  // const url = 'https://neoe2e.neophyte.live/fm-api/api/employee_footfall';
  const url = 'https://neoe2e.neophyte.live/fm-api/kpis/employeeEntranceCount';
  try {
    // const url = 'https://neoe2e.neophyte.live/fm-api/api/femployee_footfall';

    const response = await axios.post(url, body, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    const data = response.data;
    // console.log(data)
    return data;
  } catch (error) {
    console.log('Error Calling fetchTimelineData API: ', error);
    const url2 = url.replace('localhost', '10.115.67.9');
    try {
      // const url = 'https://neoe2e.neophyte.live/fm-api/api/employee_footfall';

      const response = await axios.post(url2, body, {
        headers: {
          Accept: 'application/json',
          Authorization: await token()
        }
      });
      const data = response.data;
      // console.log(data)
      return data;
    } catch (error) {
      console.log('Error Calling fetchTimelineData API: ', error);
      throw error;
    }
    // throw error;
  }
};

export const empZonewiseCount = async (body) => {
  console.log(body);
  // const url = 'https://neoe2e.neophyte.live/fm-api/api/employee_footfall';
  const url = 'https://neoe2e.neophyte.live/fm-api/kpis/zonesEmployeeCount';
  try {
    // const url = 'https://neoe2e.neophyte.live/fm-api/api/femployee_footfall';

    const response = await axios.post(url, body, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    const data = response.data;
    // console.log(data)
    return data;
  } catch (error) {
    console.log('Error Calling fetchTimelineData API: ', error);
    const url2 = url.replace('localhost', '10.115.67.9');
    try {
      // const url = 'https://neoe2e.neophyte.live/fm-api/api/employee_footfall';

      const response = await axios.post(url2, body, {
        headers: {
          Accept: 'application/json',
          Authorization: await token()
        }
      });
      const data = response.data;
      // console.log(data)
      return data;
    } catch (error) {
      console.log('Error Calling fetchTimelineData API: ', error);
      throw error;
    }
    // throw error;
  }
};

export const avgWaitingTime = async (body) => {
  console.log(body);
  // const url = 'https://neoe2e.neophyte.live/fm-api/api/employee_footfall';
  const url = 'https://neoe2e.neophyte.live/fm-api/kpis/avgWaitingTime';
  try {
    // const url = 'https://neoe2e.neophyte.live/fm-api/api/femployee_footfall';

    const response = await axios.post(url, body, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    const data = response.data;
    // console.log(data)
    return data;
  } catch (error) {
    console.log('Error Calling fetchTimelineData API: ', error);
    const url2 = url.replace('localhost', '10.115.67.9');
    try {
      // const url = 'https://neoe2e.neophyte.live/fm-api/api/employee_footfall';

      const response = await axios.post(url2, body, {
        headers: {
          Accept: 'application/json',
          Authorization: await token()
        }
      });
      const data = response.data;
      // console.log(data)
      return data;
    } catch (error) {
      console.log('Error Calling fetchTimelineData API: ', error);
      throw error;
    }
    // throw error;
  }
};

export const interactionNumbers = async (body) => {
  // const url = 'https://neoe2e.neophyte.live/fm-api/api/employee_footfall';
  const url = 'https://neoe2e.neophyte.live/fm-api/kpis/avgWaitingNull';
  try {
    // const url = 'https://neoe2e.neophyte.live/fm-api/api/femployee_footfall';

    const response = await axios.post(url, body, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    const data = response.data;
    // console.log(data)
    return data;
  } catch (error) {
    console.log('Error Calling fetchTimelineData API: ', error);
    const url2 = url.replace('localhost', '10.115.67.9');
    try {
      // const url = 'https://neoe2e.neophyte.live/fm-api/api/employee_footfall';

      const response = await axios.post(url2, body, {
        headers: {
          Accept: 'application/json',
          Authorization: await token()
        }
      });
      const data = response.data;
      // console.log(data)
      return data;
    } catch (error) {
      console.log('Error Calling fetchTimelineData API: ', error);
      throw error;
    }
    // throw error;
  }
};

export const customerAssociateRatio = async (body) => {
  console.log(body);
  // const url = 'https://neoe2e.neophyte.live/fm-api/api/employee_footfall';
  const url = 'https://neoe2e.neophyte.live/fm-api/kpis/customerAssociateRatio';
  try {
    // const url = 'https://neoe2e.neophyte.live/fm-api/api/femployee_footfall';

    const response = await axios.post(url, body, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    const data = response.data;
    // console.log(data)
    return data;
  } catch (error) {
    console.log('Error Calling fetchTimelineData API: ', error);
    const url2 = url.replace('localhost', '10.115.67.9');
    try {
      // const url = 'https://neoe2e.neophyte.live/fm-api/api/employee_footfall';

      const response = await axios.post(url2, body, {
        headers: {
          Accept: 'application/json',
          Authorization: await token()
        }
      });
      const data = response.data;
      // console.log(data)
      return data;
    } catch (error) {
      console.log('Error Calling fetchTimelineData API: ', error);
      throw error;
    }
    // throw error;
  }
};

export const assCusRatioCard = async (body) => {
  console.log(body);
  const url = 'https://neoe2e.neophyte.live/fm-api/api/interaction';
  try {
    // const url = 'https://neoe2e.neophyte.live/fm-api/api/zone_wise_custo_emp_ratio';

    const response = await axios.post(url, body, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    const data = response.data;
    // console.log(data)
    return data;
  } catch (error) {
    console.log('Error Calling fetchTimelineData API: ', error);
    const url2 = url.replace('localhost', '10.115.67.9');
    try {
      // const url = 'https://neoe2e.neophyte.live/fm-api/api/zone_wise_custo_emp_ratio';

      const response = await axios.post(url2, body, {
        headers: {
          Accept: 'application/json',
          Authorization: await token()
        }
      });
      const data = response.data;
      // console.log(data)
      return data;
    } catch (error) {
      console.log('Error Calling fetchTimelineData API: ', error);
      throw error;
    }
    // throw error;
  }
};

export const getVideoData = async () => {
  const url = 'https://i6zcdr9gb5.execute-api.eu-west-2.amazonaws.com/test/store/signedVideo';

  try {
    const response = await axios.get(url, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });

    const data = response.data;
    // console.log(data);
    return data;
  } catch (error) {
    console.log('Error Calling getVideoData API: ', error);
    throw error;
  }
};

export const fetchTimelineData = async (body) => {
  const url = 'https://neoe2e.neophyte.live/fm-api/api/engagement';
  try {
    const res = await axios.post(url, body, {
      headers: {
        Accept: 'application/json',
        Authorization: await token() // assuming token() function exists to retrieve authorization token
      }
    });
    const data = res.data;
    return data;
  } catch (error) {
    console.log('Error Calling fetchTimelineData API: ', error);
    const url2 = url.replace('localhost', '10.115.67.9');
    try {
      const res = await axios.post(url2, body, {
        headers: {
          Accept: 'application/json',
          Authorization: await token() // assuming token() function exists to retrieve authorization token
        }
      });
      // console.log('api response', res.data);
      const data = res.data;
      return data;
    } catch (error) {
      console.log('Error Calling fetchTimelineData API: ', error);
      throw error; // Rethrow the error to be handled by the calling code if needed
    }
    // throw error; // Rethrow the error to be handled by the calling code if needed
  }
};

export const getRatio = async (body) => {
  const url = 'https://neoe2e.neophyte.live/fm-api/api/employee_customer';
  try {
    // const url = 'https://neoe2e.neophyte.live/fm-api/api/getRatio';

    const response = await axios.post(url, body, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    const data = response.data;
    return data;
  } catch (error) {
    console.log('Error Calling totalEmployeeCount API: ', error);
    const url2 = url.replace('localhost', '10.115.67.9');
    try {
      // const url = 'https://neoe2e.neophyte.live/fm-api/api/getRatio';

      const response = await axios.post(url2, body, {
        headers: {
          Accept: 'application/json',
          Authorization: await token()
        }
      });
      const data = response.data;
      return data;
    } catch (error) {
      console.log('Error Calling totalEmployeeCount API: ', error);
      throw error;
    }
    // throw error;
  }
};

export const cameraCheckImg = async (body) => {
  try {
    const url = 'http://localhost:9990/camera/connect/';
    const response = await axios.post(url, body, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    const data = response.data;
    return data;
  } catch (error) {
    console.log('Error Calling fetchTimelineData API: ', error);
    throw error;
  }
};

export const addCameraWithZone = async (body) => {
  const url = 'https://neoe2e.neophyte.live/fm-api/camera/create';
  try {
    const response = await axios.post(url, body, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    const data = response.data;
    return data;
  } catch (error) {
    console.log('Error Calling fetchTimelineData API: ', error);
    try {
      const url2 = url.replace('localhost', '10.115.67.9');
      const response = await axios.post(url2, body, {
        headers: {
          Accept: 'application/json',
          Authorization: await token()
        }
      });
      const data = response.data;
      return data;
    } catch (error) {
      console.log('Error Calling fetchTimelineData API: ', error);
      throw error;
    }
    // throw error;
  }
};

// export const getStoreData = async () => {
//   try {
//     const url = 'https://neoe2e.neophyte.live/fm-api/api/store';
//     const response = await axios.get(url, {
//       headers: {
//         Accept: 'application/json',
//         Authorization: await token()
//       }
//     });
//     const data = response.data;
//     return data;
//   } catch (error) {
//     console.log('Error Calling fetchTimelineData API: ', error);
//     throw error;
//   }
// }

export const getCameraData = async () => {
  const url = 'https://neoe2e.neophyte.live/fm-api/camera/get';
  try {
    const response = await axios.get(url, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    const data = response.data;
    return data;
  } catch (error) {
    console.log('Error Calling getCameraData API: ', error);
    const url2 = url.replace('localhost', '10.115.67.9');
    try {
      const response = await axios.get(url2, {
        headers: {
          Accept: 'application/json',
          Authorization: await token()
        }
      });
      const data = response.data;
      return data;
    } catch (error) {
      console.log('Error Calling getCameraData API: ', error);
      throw error;
    }
    // throw error;
  }
};
export const getZoneData = async (body) => {
  const url = 'https://neoe2e.neophyte.live/fm-api/zone/get';
  try {
    const response = await axios.post(url, body, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    const data = response.data;
    return data;
  } catch (error) {
    console.log('Error Calling getZoneData API: ', error);
    try {
      const url2 = url.replace('localhost', '10.115.67.9');
      const response = await axios.post(url2, body, {
        headers: {
          Accept: 'application/json',
          Authorization: await token()
        }
      });
      const data = response.data;
      return data;
    } catch (error) {
      console.log('Error Calling getZoneData API: ', error);
      throw error;
    }
    // throw error;
  }
};
export const getAllZoneData = async () => {
  const url = 'https://neoe2e.neophyte.live/fm-api/zone/getAll';
  try {
    const response = await axios.get(url, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    const data = response.data;
    return data;
  } catch (error) {
    console.log('Error Calling getAllZoneData API: ', error);
    try {
      const url2 = url.replace('localhost', '10.115.67.9');
      const response = await axios.get(url2, {
        headers: {
          Accept: 'application/json',
          Authorization: await token()
        }
      });
      const data = response.data;
      return data;
    } catch (error) {
      console.log('Error Calling getAllZoneData API: ', error);
      throw error;
    }
    // throw error;
  }
};
export const deleteZoneData = async (body) => {
  const url = 'https://neoe2e.neophyte.live/fm-api/zone/delete';
  try {
    const response = await axios.post(url, body, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    const data = response.data;
    return data;
  } catch (error) {
    console.log('Error Calling deleteZoneData API: ', error);
    try {
      const url2 = url.replace('localhost', '10.115.67.9');
      const response = await axios.post(url2, body, {
        headers: {
          Accept: 'application/json',
          Authorization: await token()
        }
      });
      const data = response.data;
      return data;
    } catch (error) {
      console.log('Error Calling deleteZoneData API: ', error);
      throw error;
    }
    // throw error;
  }
};

export const deleteCamera = async (body) => {
  console.log(body);
  const url = 'https://neoe2e.neophyte.live/fm-api/camera/delete';
  try {
    const response = await axios.delete(url, {
      data: body,
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    const data = response.data;
    return data;
  } catch (error) {
    console.log('Error Calling deleteCamera API: ', error);
    try {
      const url2 = url.replace('localhost', '10.115.67.9');
      const response = await axios.delete(url2, {
        data: body,
        headers: {
          Accept: 'application/json',
          Authorization: await token()
        }
      });
      const data = response.data;
      return data;
    } catch (error) {
      console.log('Error Calling deleteCamera API: ', error);
      throw error;
    }
    // throw error;
  }
};

export const GetAllCamera = async () => {
  const url = 'https://neoe2e.neophyte.live/fm-api/camera/getAll';
  try {
    const response = await axios.get(url, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    const data = response.data;
    return data;
  } catch (error) {
    console.log('Error Calling getAllZoneData API: ', error);
    try {
      const url2 = url.replace('localhost', '10.115.67.9');
      const response = await axios.get(url2, {
        headers: {
          Accept: 'application/json',
          Authorization: await token()
        }
      });
      const data = response.data;
      return data;
    } catch (error) {
      console.log('Error Calling getAllZoneData API: ', error);
      throw error;
    }
    // throw error;
  }
};

export const GetOneCamera = async (body) => {
  const url = `${infer_localUrl}/camera/heatmap/`;
  try {
    const response = await axios.post(url, body, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      },
      responseType: 'blob'
    });
    const data = response.data;
    return data;
  } catch (error) {
    console.log('Error Calling GetOneCamera API: ', error);
    try {
      const url2 = url.replace('localhost', '10.115.67.9');
      const response = await axios.post(url2, body, {
        headers: {
          Accept: 'application/json',
          Authorization: await token()
        },
        responseType: 'blob'
      });
      const data = response.data;
      return data;
    } catch (error) {
      console.log('Error Calling GetOneCamera API: ', error);
      return null;
    }
    // return null;
  }
};

// export const GetOneCamera = async (id) => {
//   try {
//     const url = `https://neoe2e.neophyte.live/fm-api/camera/get_one_cam/${id}`;
//     const response = await axios.get(url, {
//       headers: {
//         Accept: 'application/json',
//         Authorization: await token()
//       }
//     });
//     const data = response.data;
//     return data;
//   } catch (error) {
//     console.log('Error Calling getAllZoneData API: ', error);
//     throw error;
//   }
// };

// export const totalEmployeeCount = async (body) => {
//   try {
//     const url = 'https://neoe2e.neophyte.live/fm-api/api/totalEmployee';
//     const response = await axios.post(url, body, {
//       headers: {
//         Accept: 'application/json',
//         Authorization: await token()
//       }
//     });
//     const data = response.data;
//     return data;
//   } catch (error) {
//     console.log('Error Calling totalEmployeeCount API: ', error);
//     throw error;
//   }
// };
